module.exports = __webpack_public_path__ + "static/media/silviaFazio.657e8246.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/silviaFazio.jpg
// module id = 1695
// module chunks = 1